
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import SidebarItem from "./SidebarItem";
import { SidebarRouteItem } from "./sidebarRoutes";

interface MobileSidebarProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  authorizedRoutes: SidebarRouteItem[];
}

const MobileSidebar = ({ isOpen, setIsOpen, authorizedRoutes }: MobileSidebarProps) => {
  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div 
        className={cn(
          "fixed inset-y-0 left-0 z-50 w-64 border-r bg-background transform transition-transform duration-300 ease-in-out",
          isOpen ? "translate-x-0" : "-translate-x-full"
        )}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="font-semibold">Menu</h2>
          <Button 
            variant="ghost" 
            size="icon" 
            onClick={() => setIsOpen(false)}
            className="hover:bg-secondary"
          >
            <X className="h-5 w-5" />
          </Button>
        </div>
        <ScrollArea className="flex-1 p-4 h-[calc(100vh-64px)]">
          <div className="flex flex-col gap-1">
            {authorizedRoutes.map((route) => (
              <SidebarItem
                key={route.href}
                title={route.title}
                icon={route.icon}
                href={route.href}
                onClick={handleLinkClick}
              />
            ))}
          </div>
        </ScrollArea>
      </div>
      
      {/* Backdrop to close sidebar when clicking outside */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 md:hidden" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default MobileSidebar;
